export default __webpack_public_path__ + "static/media/CapacitanceImg.5b9d477d.jpg";